import { render, staticRenderFns } from "./SelectDoctorTemplate.vue?vue&type=template&id=64085595&"
import script from "./SelectDoctorTemplate.vue?vue&type=script&lang=js&"
export * from "./SelectDoctorTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports